import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { blackjack } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A ONE BLACKJACK TABLE */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={blackjack.api} config={blackjack} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
